<template>
    <div>
        <div class="pt-5 pb-5" v-if="item.itemDetails">

            <div class="pt-4"></div>
            <v-tabs
                    v-model="tabs"
                    active-class="tabActive"
            >
                <v-tabs-slider color="white"></v-tabs-slider>

                <v-tab
                        :key="0"
                >
                    Beschreibung
                </v-tab>
                <v-tab
                        :key="1"
                >
                    Details
                </v-tab>

            </v-tabs>
            <v-tabs-items
                    v-model="tabs"
            >
                <v-tab-item
                        :ripple="false"
                        :key="0"
                >
                    <div v-html="item.descriptionDE"></div>
                </v-tab-item>
                <v-tab-item
                        :ripple="false"
                        :key="1"
                >
                    <div v-html="item.itemDetails"></div>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            item: Object,
        },
        data: () => ({
            tabs: 0,
        }),

        mounted() {
            //Bugfix workaround https://github.com/vuetifyjs/vuetify/issues/10455
            setTimeout(() => {
                this.tabs = 1;
            }, 800);
            // let so =true;
            // setInterval(()=>{
            //    if(so){
            //        this.tab = 'details';
            //    } else{
            //        this.tab = 'description';
            //    }
            //    so = !so;
            // },2000);
            // setTimeout(() => {
            //     this.tab = 'details';
            // }, 100);
            // setTimeout(() => {
            //     this.tab = 'description';
            // }, 200);
        }

    }
</script>

<style scoped lang="scss">

</style>